import { ProductionFulfillmentApi } from "../../client-efs";
import { APIOptionsWithoutAPIClass, useAPI } from "./useAPI";

export const useProductionFulfillmentApi = <T>({
  initialValue,
  handleRequest,
}: APIOptionsWithoutAPIClass<T, ProductionFulfillmentApi>) => {
  return useAPI<T, ProductionFulfillmentApi>({
    initialValue,
    APIClass: ProductionFulfillmentApi,
    handleRequest,
  });
};
